import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsStepperComponent } from "./ds-stepper.component";
import { DsStepperNextDirective } from "../directive/ds-stepper-next.directive";
import { DsStepperPreviousDirective } from "../directive/ds-stepper-previous.directive";
import { DsStepModule } from "../ds-step/ds-step.module";
import { DsIconModule } from "../ds-icon/ds-icon.module";
import { DsFooterStepperComponent } from "./ds-footer-stepper/ds-footer-stepper.component";
import { DsButtonModule } from "../ds-button/ds-button.module";
@NgModule({
  declarations: [DsStepperComponent, DsFooterStepperComponent],
  imports: [
    CommonModule,
    DsStepModule,
    DsStepperNextDirective,
    DsStepperPreviousDirective,
    DsIconModule,
    DsButtonModule,
  ],
  exports: [
    DsStepperComponent,
    DsStepModule,
    DsStepperNextDirective,
    DsStepperPreviousDirective,
    DsFooterStepperComponent,
  ],
})
export class DsStepperModule {}
